import React, {useEffect, useState} from "react";
import './BlogList.scss';
import './BlogInfo.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import Footer from "../../components/Footer";
import {useParams} from "react-router-dom";

let img_top = require("../../assets/mushroom/26.webp");

function BlogInfo() {
    useEffect(() => {
        document.title = "Geoticket - Blog";
    }, []);
    const {sku} = useParams();

    const [post, setPost] = useState(null);

    useEffect(() => {
        fetch(global.route.blogInfo, {
            method: "post",
            credentials: 'include',
            body: global.getFormData({sku: sku})

        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        document.title = "Geoticket - " + response.blog.title;
                        setPost(response.blog);
                    });
                }
            });
    }, []);

    let title = <>Il nostro <b><span className={"orange"}>Blog</span></b></>
    let img_bg = "";
    if (post !== null) {
        title = post.title;
        if (post.image !== null)
            img_bg = global.baseUrl + post.image;
        else
            img_bg = img_top;
    }

    let getPost = () => {
        if (post === null)
            return;
        let result = [];
        if (post.toc !== null) {
            result.push(<div className={"card"}>
                <div className={"card-body"}><b>Tabella contenuti</b>
                    <ol>{post.toc.map(item =>
                        <li key={item.id}>
                            <a href={item.id}>
                                <div dangerouslySetInnerHTML={{__html: item.name}}/>
                            </a>
                        </li>
                    )}</ol>
                </div>
            </div>)
        }
        if (post.body !== null)
            result.push(<div className="blog-post-body" dangerouslySetInnerHTML={{__html: post.body}}/>);

        if (post.buttonUrl !== null)
            result.push(<div className={"d-flex justify-content-center"}><Button href={post.buttonUrl}
                                                                                 className="btn-orange">Acquista
                permesso</Button></div>);
        return result;
    }

    return (
        <div style={{backgroundColor: "#fafafa"}}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_bg}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">{title}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container mt-4 mb-4"}>
                {getPost()}
            </div>
            <Footer/>
        </div>
    );
}

export default BlogInfo;